import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to="/products"
      data-testid={`product-card-${product.id}`}
      data-cursor="hover"
      className="group block"
    >
      <div className="relative overflow-hidden rounded-3xl border border-line bg-sand">
        <span className="absolute left-4 top-4 z-10 rounded-full bg-cream/90 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-forest backdrop-blur">
          {product.tag}
        </span>
        <div className="aspect-[4/5] w-full overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            loading={index > 2 ? "lazy" : "eager"}
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-heading text-xl text-forest">{product.name}</h3>
          <p className="mt-1 text-sm text-ink/60">{product.subtitle}</p>
        </div>
        <div className="text-right">
          <p className="font-heading text-lg text-forest">{product.price}</p>
          <p className="text-xs text-ink/50">{product.size}</p>
        </div>
      </div>
    </Link>
  );
}
